import { log } from "@repo/helpers";
import { KeyPairArray } from "@repo/models";

import { ComponentValidationResult, MappedDyno } from "../models/mappedComponent";

export default class ValidationResults extends KeyPairArray<string | ComponentValidationResult> {
	constructor(data: ComponentValidationResult[]) {
		const adjusted = data.map((d) => ({
			id: mapComponentToId(d.component),
			value: d.value,
		}));
		super(adjusted);
	}

	getError(component: MappedDyno) {
		if (!component) return null; //TODO: just put this in as a hack
		return super.getValue(mapComponentToId(component)) as string;
	}
}

function mapComponentToId(component: MappedDyno) {
	if (!component) {
		//we want soft failing so validation at least tries to work
		log("Attempted to map undefined component", "error");
		return "error";
	}
	return `${component.id}-${component.propertyName}`;
}
